import { render, staticRenderFns } from "./AdvCartGiftRowGroup.vue?vue&type=template&id=b23360ea"
import script from "./AdvCartGiftRowGroup.vue?vue&type=script&lang=js"
export * from "./AdvCartGiftRowGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports